import { createFileRoute } from '@tanstack/react-router'
import { MedicalSurveyTab } from '@/pages/donor-detail/ui/MedicalSurveyTab'

function MedicalSurveyRoute() {
  const { visitId } = Route.useParams()
  return <MedicalSurveyTab visitId={visitId} />
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/medical-survey',
)({
  component: MedicalSurveyRoute,
})
